import { styled, css } from "styled-components";
import { mobileBreakPointCSS } from "../../defaults/theme.js";

interface WrapperProps {
  $hasValue?: boolean;
  $errorMessage?: string;
  required?: boolean;
}

const Wrapper = styled.div<{ $disabled: boolean }>`
  transition: opacity 0.1s ease-in-out;
  position: relative;

  ${(props) =>
    props.$disabled &&
    css`
      opacity: 0.5;
    `};
`;

const Label = styled.label`
  font-weight: 600;
  margin-bottom: ${(props) => props.theme.spacing.xs};
  display: block;
`;

const StyledSelect = styled.select<WrapperProps>`
  height: 50px;
  width: 100%;
  background-color: #fff;
  color: var(--swatch2);
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 5px;
  padding: 0 0.75rem;
  outline: none;
  transition: border-color 0.1s ease-in-out;

  @media (min-width: ${mobileBreakPointCSS}) {
    min-width: 250px;
  }

  &:active,
  &:focus {
    border-color: var(--swatch1);
  }

  &:disabled {
    opacity: 0.5;
    pointer-events: none;
  }

  ${(props) =>
    props.$hasValue &&
    css`
      border-color: var(--swatch2);
    `};

  ${(props) =>
    !!props.$errorMessage &&
    css`
      border-color: var(--error);
    `};

  ${(props) =>
    !!props.required &&
    css`
      border-color: var(--swatch1);
    `};
`;

const StatusWrapper = styled.div<{ $error?: boolean }>`
  display: flex;
  justify-content: flex-end;
  margin-top: calc(${(props) => props.theme.spacing.xs}) / 2;

  ${(props) =>
    props.$error &&
    css`
      color: var(--error);
    `};
`;

interface Props extends React.InputHTMLAttributes<HTMLSelectElement> {
  errorMessage?: string;
  label?: string;
}

export const Select: React.FC<Props> = ({
  required = false,
  errorMessage = "",
  disabled = false,
  label,
  children,
  ...restProps
}) => {
  return (
    <Wrapper $disabled={disabled}>
      {label && (
        <Label>
          {label} {required && "*"}
        </Label>
      )}
      <StyledSelect
        className="b1"
        required={required}
        $errorMessage={errorMessage}
        disabled={disabled}
        {...restProps}
      >
        {children}
      </StyledSelect>
      {!!errorMessage && (
        <StatusWrapper className="b1" $error>
          {errorMessage}
        </StatusWrapper>
      )}
    </Wrapper>
  );
};
